import { ResourceRegionType } from '#shared';

export const subRegionMap: Record<ResourceRegionType, string[]> = {
  [ResourceRegionType.West]: ['West', 'Southwest'],
  [ResourceRegionType.East]: ['Northeast', 'Southeast'],
  [ResourceRegionType.North]: ['Midwest'],
  [ResourceRegionType.South]: ['South'],
};

export const regionToStatesMap = {
  south: ['TX', 'KS'],
  west: ['WA', 'UT', 'CA', 'AZ', 'CO'],
  north: ['MN', 'IL', 'MI', 'OH'],
  east: ['MA', 'NJ', 'NC', 'GA', 'FL', 'PA'],
};
